import ResetSlideShowButton from './ResetSlideShowButton';

export default ResetSlideShowButton;
